import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import { RewardProviderType } from '@kudos/http-client'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const RewardsRoute = lazyWithRetries(() => import('.'))
const UpdateRewardProvider = lazyWithRetries(() => import('./UpdateRewardProvider'))
const ConfigureTangoRewardProvider = lazyWithRetries(() => import('./tango'))
const MyRewardStoreRoute = lazyWithRetries(() => import('./tango/myRewardStore/MyRewardStore'))
const AddTangoRewardFunds = lazyWithRetries(() => import('./tango/addFunds/AddFunds'))
const ConfigureCustomRewardProviderRoute = lazyWithRetries(
  () => import('./custom/configureCustomRewardProvider'),
)
const CustomRewardProviderRoute = lazyWithRetries(() => import('./custom'))
const ConfigureCustomRewardRoute = lazyWithRetries(
  () => import('./custom/reward/configureCustomReward'),
)
const DuplicateCustomRewardRoute = lazyWithRetries(
  () => import('./custom/reward/duplicateCustomReward'),
)
const BulkCompleteCustomRewardOrdersRoute = lazyWithRetries(
  () => import('./custom/reward/bulkCompleteOrders'),
)
const CustomRewardRoute = lazyWithRetries(() => import('./custom/reward'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.rewards('setup'),
    element: (
      <StandardPageLayout elementId="rewardsRoute" title={<T _str="Rewards" />} maxWidth={1440}>
        <Suspense fallback={<RouteLoading />}>
          <RewardsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.editRewardProvider(':rewardProviderId'),
    element: (
      <StandardPageLayout elementId="updateRewardProvider" maxWidth={600}>
        <Suspense fallback={<RouteLoading />}>
          <UpdateRewardProvider />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.configureRewardProvider(
      RewardProviderType.TANGO,
      ':rewardProviderId?',
    ),
    element: (
      <StandardPageLayout elementId="configureTangoRewardProvider" maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureTangoRewardProvider />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.rewardProvider(RewardProviderType.TANGO, ':rewardProviderId'),
    element: (
      <StandardPageLayout
        elementId="tangoRewardProvider"
        maxWidth={900}
        title={<T _str="My reward store" />}>
        <Suspense fallback={<RouteLoading />}>
          <MyRewardStoreRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.addTangoRewardFunds(':rewardProviderId'),
    element: (
      <StandardPageLayout
        elementId="addTangoRewardFunds"
        maxWidth={600}
        title={<T _str="Add funds" />}>
        <Suspense fallback={<RouteLoading />}>
          <AddTangoRewardFunds />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.configureRewardProvider(
      RewardProviderType.CUSTOM,
      ':rewardProviderId?',
    ),
    element: (
      <StandardPageLayout elementId="configureCustomRewards" maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureCustomRewardProviderRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.rewardProvider(RewardProviderType.CUSTOM, ':rewardProviderId'),
    element: (
      <StandardPageLayout elementId="CustomRewardStore" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <CustomRewardProviderRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.configureCustomReward(':rewardProviderId', ':customRewardId?'),
    element: (
      <StandardPageLayout elementId="customReward" maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureCustomRewardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.customReward(':rewardProviderId', ':customRewardId', ':tab?'),
    element: (
      <StandardPageLayout elementId="customReward" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <CustomRewardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.duplicateCustomReward(':rewardProviderId', ':customRewardId'),
    element: (
      <StandardPageLayout elementId="customReward" maxWidth={900} title={<T _str="Add reward" />}>
        <Suspense fallback={<RouteLoading />}>
          <DuplicateCustomRewardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.bulkCompleteCustomOrders(
      ':rewardProviderId',
      ':customRewardId',
      ':batchId',
    ),
    element: (
      <StandardPageLayout
        elementId="customReward"
        maxWidth={600}
        title={<T _str="Mark redemption as complete" />}>
        <Suspense fallback={<RouteLoading />}>
          <BulkCompleteCustomRewardOrdersRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
